<template>
  <div class="chartElem">
    <div class="row">
      <highcharts :options="chartOptions"></highcharts>
    </div>
  </div>
</template>

<script>
export default {
  name: "chart",
  data() {
    return {
      chartOptions: {
        chart: {
          height: "100%"
        },
        title: {
          text: "World population 2017"
        },
        subtitle: {
          text:
            'Source <href="https://en.wikipedia.org/wiki/List_of_countries_by_population_(United_Nations)">Wikipedia</a>'
        },
        series: [
          {
            type: "sunburst",
            data : null,
            allowDrillToNode: true,
            cursor: "pointer",
            dataLabels: {
              format: "{point.name}",
              filter: {
                property: "innerArcLength",
                operator: ">",
                value: 16
              }
            },
            levels: [
              {
                level: 1,
                levelIsConstant: false,
                dataLabels: {
                  filter: {
                    property: "outerArcLength",
                    operator: ">",
                    value: 64
                  }
                }
              },
              {
                level: 2,
                colorByPoint: true
              },
              {
                level: 3,
                colorVariation: {
                  key: "brightness",
                  to: -0.5
                }
              },
              {
                level: 4,
                colorVariation: {
                  key: "brightness",
                  to: 0.5
                }
              }
            ]
          }
        ],
        tooltip: {
          headerFormat: "",
          pointFormat:
            "The population of <b>{point.name}</b> is <b>{point.value}</b>"
        }
      },
      title: ""
    };
  }
};
</script>

<style scoped>
input[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
}
#colorPicker {
  border: 0;
  padding: 0;
  margin: 0;
  width: 30px;
  height: 30px;
}
.numberInput {
  width: 30px;
}
</style>
